import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';

export interface IHistoricoPdf {
  id: number;
  patient_id: number;
  file_path: string;
  file_name: string;
  file_size: number | null;
  mime_type: string | null;
  file_url: string;
  created_at: string;
  updated_at: string;
}

@Injectable({ providedIn: 'root' })
export class PatientHistoricoPdfService {
  constructor(private apiService: ApiService) {}

  async getByPatient(patientId: number | string): Promise<IHistoricoPdf[]> {
    const response = await firstValueFrom(
      this.apiService.get<{ success: boolean; data: IHistoricoPdf[] }>(
        `patients/${patientId}/historico-pdfs`
      )
    );

    return response?.data ?? [];
  }

  async upload(patientId: number | string, file: File): Promise<IHistoricoPdf> {
    const formData = new FormData();
    formData.append('patient_id', String(patientId));
    formData.append('pdf', file);

    const response = await firstValueFrom(
      this.apiService.postFormData<{ success: boolean; data: IHistoricoPdf }>(
        'historico-pdfs',
        formData
      )
    );

    return response.data;
  }

  async delete(id: number | string): Promise<void> {
    await firstValueFrom(this.apiService.delete(`historico-pdfs/${id}`));
  }
}
